import React, { useContext, useEffect } from 'react';
import { SitecoreContext, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import './index.scss';
import { ICustomContext } from '../../model/ICustomContext';
import { simpleUniqueId } from '../../utils/helper';

type LangugageSelectorEditorProps = {
  sitecoreContext: SitecoreContext & {
    pageEditing: boolean;
    custom: ICustomContext;
    language: string;
    itemId: string;
  };
};

const LangugageSelector = ({ sitecoreContext }: LangugageSelectorEditorProps): JSX.Element => {
  const [languages, setLanguages] = React.useState<Record<string, string>>({});
  const [language, setLanguage] = React.useState<string>('');

  const context = React.createContext(sitecoreContext);
  const currentContext = useContext(context);

  useEffect(() => {
    const languageList = sitecoreContext?.custom?.siteConfiguration?.siteLanguages || [];
    const newLanguages: Record<string, string> = {};

    languageList.forEach((language) => {
      const abbreviation = language.abbreviation;
      const label = language.label;
      newLanguages[abbreviation] = label;
    });

    setLanguages(newLanguages);

    const langCode = sitecoreContext?.language;
    if (langCode) {
      setLanguage(newLanguages[langCode]);
    }
  }, [sitecoreContext]);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedValue = event.target.value;

    if (typeof selectedValue === 'string') {
      setLanguage(selectedValue);

      const selectedCode = Object.keys(languages).find((code) => languages[code] === selectedValue);

      const targetUrl = currentContext?.custom?.urlPathTranslations[selectedCode || ''];
      if (targetUrl && typeof window !== 'undefined') {
        window.location.href = targetUrl;
      }
    }
  };

  function getMenuLinks() {
    return Object.keys(languages).map((key) => {
      const label = languages[key];
      return (
        <MenuItem key={key} role="menuitem" aria-label={`Language: ${label}`} value={label}>
          {label}
        </MenuItem>
      );
    });
  }

  return (
    <div className="language-selector">
      <img loading="lazy" alt="globe-icon" src="/-/media/Project/UPMC/Italy/Icons/iconglobe.svg" />
      <Select
        id={simpleUniqueId('languageSelect')}
        role="region"
        aria-label="Language Selector"
        displayEmpty
        value={language}
        onChange={handleChange}
        className="language-selection"
      >
        {getMenuLinks().map((link) => link)}
      </Select>
    </div>
  );
};

export default withSitecoreContext()(LangugageSelector);
